import * as React from 'react';
import styled from 'styled-components';
import Headline from '@adecco/base-app/src/components/atoms/Headline/Headline';
import { moreThan } from '@adecco/base-app/src/constants/breakpoints/breakpoints';
import Fact, { IFact } from '@adecco/base-app/src/components/atoms/Fact/Fact';
import { grid_1_2_3 } from '@adecco/base-app/src/styles/grids';
import Container from '@adecco/base-app/src/components/atoms/Container/Container';

export interface IFactList {
  title: string;
  entries: ReadonlyArray<IFact>;
  centeredHeadline?: boolean;
}

const FactListItems = styled.div`
  ${grid_1_2_3};
  gap: ${(props) => props.theme.gaps.factList};
`;

const FactListItem = styled.div`
  &:not(:last-child) {
    margin-bottom: ${(props) => props.theme.margins.listItem};
  }

  ${moreThan('md')} {
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

const FactHeadline = styled(Headline)`
  font-family: ${(props) => props.theme.fonts.HeadlineBold};
  margin-bottom: ${(props) => props.theme.margins.fact};
  font-size: ${(props) => props.theme.fontSizes.headline2};
  line-height: ${(props) => props.theme.lineHeights.headline2};

  ${moreThan('md')} {
    font-size: ${(props) => props.theme.fontSizes.factListHeadlineWideScreen};
    line-height: ${(props) => props.theme.lineHeights.headline2WideScreen};
  }
`;

const FactList: React.FunctionComponent<IFactList> = ({ title, entries, centeredHeadline }) => {
  return (
    <Container>
      <FactHeadline skin={2} centered={centeredHeadline}>
        {title}
      </FactHeadline>
      <FactListItems>
        {entries.map((entry, index) => (
          <FactListItem key={`jobFact-${index}`}>
            <Fact {...entry} />
          </FactListItem>
        ))}
      </FactListItems>
    </Container>
  );
};

export default FactList;
